import { UnitType } from "types/app";

export const formatTemperature = (
  celsius: number,
  unitType: UnitType,
  decimals: number
) => {
  const unitName = unitType === "metric" ? "°C" : "°F";
  const temperature = unitType === "metric" ? celsius : (celsius * 9) / 5 + 32;
  return `${temperature.toFixed(decimals)} ${unitName}`;
};
